import 'reflect-metadata'
import { define, type, auto, Record, Collection } from 'type-r'
import { openDB, deleteDB } from 'idb';

import Store from './store.js'

import SkinCancerForm from '#forms/skin_cancer.js'

@define
export default class SkinCancerFormStore extends Store {
    @(type(SkinCancerForm).events({"change": "formchange"}).as) skinCancerForm: SkinCancerForm
}

const store = window.store = new SkinCancerFormStore({ id: "skin-cancer" })
export { store };
